<div class="page">
    <div class="page_header">
        <h1 class="page_title">Critérios de sustentabilidade</h1>
        <div class="page_action" style="gap: 20px">
            <a href="javascript:void(0);"
               (click)="newSustainability()"
               class="page_action_excel btn btn-warning"
               type="button">
                <svg-icon src="assets/svg/plus-circle.svg"></svg-icon>
                <span class="ml-2 font-weight-normal">{{'newCriteria' | translate}}</span>
            </a>
        </div>
    </div>
    <div class="page_padding">
        <div class="page_filter mb-4">
            <div class="input-material">
                <input id="search" [(ngModel)]="searchTerm" class="form-control" type="text" required />
                <label for="search">
                    <svg-icon src="assets/svg/search.svg"></svg-icon>
                    Busca
                </label>
            </div>
            <div class="page_filter_action flex-grow-1" style="max-width: 109px;">
                <a href="javascript:void(0)"
                   class="btn btn-block btn-lg btn-primary btn-search"
                   style="font-weight: normal;"
                   type="button"
                   (click)="search()">Buscar</a>
            </div>
        </div>
        
        

        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                    <tr>
                        <th scope="col" class="w-10"></th>
                        <th scope="col">Indicador</th>
                        <th scope="col">Tipo de redução</th>
                        <th scope="col">Métrica</th>
                        <th scope="col">Valor de conversão em CO2eq</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of filteredIndicatorCalculationList">
                        <td>
                            <div class="d-flex justify-content-center" style="gap: 15px">
                                <svg-icon class="is-cursor" (click)="editSustainability(item)" src="assets/svg/edit.svg"></svg-icon>
                                <svg-icon class="is-cursor" (click)="deleteSustainability(item.id)" src="assets/svg/close-circle.svg"></svg-icon>
                            </div>
                        </td>
                        <td>{{ item.indicator }}</td>
                        <td>{{ item.reductionType }}</td>
                        <td>{{ item.metric }}</td>
                        <td>{{ item.conversionFactor }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="modalSustainability" data-keyboard="false" data-backdrop="static" role="dialog" aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 560px" role="document">
        <div class="modal-content modal-user">
            <div class="modal-header">
                <h2 class="modal-user_title">Critérios de sustentabilidade</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-user_body">
                <div class="modal-user_card">
                    <fieldset class="custom__form" autocomplete="off">
                        <div class="row">
                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <select id="iptIndicador" [(ngModel)]="IndicatorCalculationData.indicator" class="form-control" name="retornoType">
                                        <option [ngValue]="undefined" selected>Selecione</option>
                                        <option *ngFor="let option of indicatorOptions" [ngValue]="option">{{ option }}</option>
                                    </select>
                                    <label for="iptIndicador">Indicador</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <select id="iptType" [(ngModel)]="IndicatorCalculationData.reductionType" class="form-control">
                                        <option [ngValue]="undefined" selected>Selecione</option>
                                        <option *ngFor="let option of reductionTypeOptions" [ngValue]="option">{{ option }}</option>
                                    </select>
                                    <label for="iptType">Tipo de redução</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <select id="iptMetrica" [(ngModel)]="IndicatorCalculationData.metric" class="form-control">
                                        <option [ngValue]="undefined" selected>Selecione</option>
                                        <option *ngFor="let option of metricOptions" [ngValue]="option">{{ option }}</option>
                                    </select>
                                    <label for="iptMetrica">Métrica</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="input-material custom__input modal_text_input">
                                    <input id="iptValuemax" [(ngModel)]="IndicatorCalculationData.conversionFactor" class="form-control" type="number" />
                                    <label for="iptValuemax">Valor de conversão em CO2eq</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <a class="btn btn-block btn-lg btn-primary text-warning" (click)="saveSustainability()">SALVAR</a>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>
